import { UrlMatchResult, UrlSegment } from "@angular/router";

import { LOCAL_ID_PREFIX } from "src/app/core";

/**
 * Matches a single segment shaped `local-<clientId>` and exposes it as `localId`.
 *
 * A matcher rather than a `path`, because the local handle and a real reservation number share one
 * segment — `view/local-3f2a…` and `view/12345` — and the plan (§8.3) specifies that shape. Angular
 * cannot express "this parameter, but only when it starts with `local-`" in a path string, and the
 * alternative of `view/local/:clientId` would have been a different URL from the one the rest of the
 * design is written against.
 *
 * Registered **before** `:reservationNumber`, so the pending view wins the segment it owns and every
 * other id still reaches `TicketComponent` untouched.
 */
export const localReservationMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length !== 1) return null;

  const [segment] = segments;
  if (!segment.path.startsWith(LOCAL_ID_PREFIX)) return null;

  return { consumed: segments, posParams: { localId: segment } };
};
